import React from 'react';
import { XCircle, Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';
const pains = ['Ganas menos de $3.000 usd y no te alcanza para la vida que deseas y mereces vivir', 'Queres trabajar remoto y no sabes por dónde empezar', 'Sentís que Improvisas', 'El algoritmo "te odia"', 'Te da vergüenza grabarte', 'Estás atrapada en una rutina que no te llena y no sabes cómo salir de ahí...', 'Ya creas contenido pero no seguis una estrcutura validada que te genere ventas'];
export function IntroSection() {
  return <section className="px-6 py-8 flex flex-col items-center text-center max-w-7xl mx-auto" data-id="element-180">
      <div className="w-full max-w-5xl relative rounded-[2.5rem] p-[2px] bg-gradient-to-b from-[#D98BAF]/80 via-brand-pinkDark/30 to-transparent shadow-[0_20px_60px_-15px_rgba(217,139,175,0.4)]" data-id="element-181">
        <div className="bg-brand-navy rounded-[2.4rem] px-6 py-10 md:px-12 md:py-12 relative overflow-hidden flex flex-col items-center" data-id="element-182">
          {/* Ambient neon glow */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-[#D98BAF]/15 blur-[120px] rounded-full pointer-events-none" data-id="element-183" />

          <h2 className="neon-title font-black text-[32px] md:text-[54px] leading-[1.1] tracking-tight uppercase mb-8 max-w-3xl" style={{
          fontFamily: "'Inter', sans-serif",
          fontWeight: 900
        }} data-id="element-184">
            ¿Te identificas con alguna de estas situaciones?
          </h2>

          <ul className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-10 relative z-10" data-id="element-185">
            {pains.map((item, i) => <motion.li key={i} initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.1
          }} className="flex items-start gap-4 justify-center px-5 py-5 bg-white/[0.03] backdrop-blur-md rounded-2xl border border-white/10 shadow-sm md:justify-start transition-all hover:border-[#D98BAF]/50 hover:bg-white/[0.06]" data-id="element-186">
                <XCircle className="text-[#D98BAF] shrink-0 mt-0.5 drop-shadow-[0_0_8px_rgba(217,139,175,0.6)]" size={24} strokeWidth={2.5} data-id="element-187" />
                <span className="font-medium text-white/80 text-[15px] leading-relaxed text-left" data-id="element-188">
                  {item}
                </span>
              </motion.li>)}
          </ul>

          <div className="flex flex-col items-center mb-14 relative z-10" data-id="element-189">
            <div className="inline-flex items-center gap-2 bg-[#D98BAF]/15 border border-[#D98BAF]/40 text-[#D98BAF] font-bold text-[12px] md:text-sm uppercase tracking-[0.2em] px-6 py-2.5 rounded-full mb-6 backdrop-blur-sm" data-id="element-190">
              <Sparkles size={16} strokeWidth={2.5} data-id="element-191" />
              Mi historia
            </div>
            <p className="font-serif italic font-bold text-3xl md:text-5xl text-white mb-6 drop-shadow-md" data-id="element-192">
              Yo también estuve ahí... 💔
            </p>
            <p className="text-brand-cream/70 font-medium leading-relaxed text-lg md:text-2xl max-w-2xl" data-id="element-193">
              Trabajaba en una oficina de 9 a 18 hs incluidos feriados, atrapada
              en una rutina que no me hacía feliz.
            </p>
          </div>

          {/* Mirror Selfie */}
          <div className="w-full max-w-md relative mb-16 mt-4 z-10" data-id="element-194">
            <div className="absolute -inset-4 bg-gradient-to-tr from-[#D98BAF]/40 via-brand-lavender/20 to-[#D98BAF]/40 rounded-[3rem] shadow-[0_0_50px_rgba(217,139,175,0.3)] transform -rotate-2 blur-md" data-id="element-195"></div>
            <div className="relative rounded-[2.5rem] p-1.5 bg-gradient-to-tr from-[#D98BAF] to-brand-pinkDark transform -rotate-2" data-id="element-196">
              <img src="https://cdn.magicpatterns.com/uploads/f6Gtv3SeReAZTr37breShA/pasted-image.png" alt="Brenda creadora UGC" className="w-full h-auto rounded-[2.2rem] relative z-10 object-cover aspect-[3/4] shadow-2xl bg-brand-navy" data-id="element-197" />
            </div>
            <div className="absolute -bottom-6 -right-4 text-6xl z-20 animate-bounce drop-shadow-[0_0_15px_rgba(255,255,255,0.5)]" data-id="element-198">
              ✨
            </div>
          </div>

          <p className="text-white font-medium text-xl md:text-3xl leading-relaxed px-4 max-w-4xl relative z-10" data-id="element-199">
            Pero eso cambió. Cuando aprendí a Crear Contenido UGC, empecé a{' '}
            <strong className="font-black text-transparent bg-clip-text bg-gradient-to-r from-[#D98BAF] to-[#fce7f1] drop-shadow-[0_0_10px_rgba(217,139,175,0.5)]" data-id="element-200">
              FACTURAR EN GRANDE
            </strong>{' '}
            y cambiar mi vida por completo.
          </p>
        </div>
      </div>
    </section>;
}